<template>
  <v-dialog
    :value="showDialog"
    width="800"
    persistent
    scrollable
  >
    <v-card>
      <AdCardTitle dialog>{{ $t('clone-valueset') }}</AdCardTitle>
      <v-card-text >
        <v-form v-model="formIsValid" ref="form">
          <v-container>
            <v-row dense>
              <v-col cols="12">
                <AdInfoOwl>{{ $t('clone-valueset-hint') }}</AdInfoOwl>
                <v-autocomplete
                  v-model="formInputs.valueset"
                  :items="valueSets"
                  item-value="uuid"
                  :label="$t('value-set')"
                  return-object
                  clearable
                  open-on-clear
                  :filter="valuesetFilter"
                >
                  <template v-slot:[`item`]="{ item }">
                    <AdStatusDot tooltip larger class="mr-3" :status="item.statusCode" icon="mdi-heart" />
                    {{ $filters.getMatchingTranslation({ value: item.name, locale: $i18n.locale })}}
                    <span v-if="item.versionLabel || item.effectiveDate" style="white-space: break-spaces"> ({{ item.versionLabel || $filters.formatDateShort(item.effectiveDate) }})</span>
                  </template>
                  <template v-slot:[`selection`]="{ item }">
                    <AdStatusDot class="mr-2" tooltip :status="item.statusCode" icon="mdi-heart" />
                    {{ $filters.getMatchingTranslation({ value: item.name, locale: $i18n.locale })}}
                    <span v-if="item.versionLabel || item.effectiveDate" style="white-space: break-spaces"> ({{ item.versionLabel || $filters.formatDateShort(item.effectiveDate) }})</span>
                  </template>
                </v-autocomplete>
              </v-col>
              <!-- Keep IDs -->
              <v-col cols="9">
                <EditableSwitch
                  v-model="formInputs.keepIds"
                  :label="$t('keep-ids')"
                />
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="1" align-self="center">
                <EditableInfoIcon :infoText="$t('keep-ids-valueset-hint')" />
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions class="dialogbottomstrip">
        <v-spacer></v-spacer>
        <AdButton type="cancel" @click="$emit('cancel')" :disabled="disabled || isCloning" />
        <AdButton type="clone" @click="handleClone" :disabled="disabled || !formIsValid || isCloning" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { isEmpty } from 'lodash'

export default {
  name: 'ValueSetClone',
  props: {
    showDialog: {
      type: Boolean,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autoSelect: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data () {
    return {
      formIsValid: false,
      formInputs: {
        valueset: null,
        keepIds: 'false'
      },
      isCloning: false
    }
  },
  computed: {
    valueSets () {
      return this.$store.getters['terminology/getFullValueSetList']()
    }
  },
  methods: {
    valuesetFilter (item, queryText, itemText) {
      const name = this.$filters.getMatchingTranslation({ value: item.name }).toLowerCase()
      const search = queryText.toLowerCase()
      return name.includes(search)
    },
    async handleClone () {
      if (this.$refs.form.validate()) {
        try {
          this.isCloning = true
          const { keepIds } = this.formInputs
          const sourceId = this.formInputs.valueset?.id
          const sourceEffectiveDate = this.formInputs.valueset?.effectiveDate

          const params = {
            keepIds,
            prefix: this.projectInFocus?.prefix,
            sourceId,
            sourceEffectiveDate
          }
          this.$store.commit('terminology/preserveValueSetItemOnSelect', true)
          const setItem = this.autoSelect
          await this.$store.dispatch('terminology/cloneValueSet', { params, setItem })
            .then(() => this.$store.commit('terminology/preserveValueSetItemOnSelect', false))
            .catch(() => {})
          this.$emit('cancel')
        } catch (error) {
          this.$emit('cancel')
          const errorMessage = error?.response?.data?.description || error?.response?.statusText || error.message || 'Error'
          this.$oops(errorMessage)
        }
        this.isCloning = false
      }
    }
  },
  watch: {
    showDialog: {
      immediate: true,
      handler (newVal) {
        if (newVal) {
          // Find the valueSet that corresponds with the selected valueSet by the user
          const id = this.$store.getters['terminology/valueSetActive']?.id ||
                this.$store.getters['terminology/valueSetActive']?.ref
          const effectiveDate = this.$store.getters['terminology/valueSetItem']?.effectiveDate ||
                           this.$store.getters['terminology/valueSetActive']?.effectiveDate
          const selectedValueSet = this.valueSets.find(vs => (vs.id === id || vs.ref === id) && vs.effectiveDate === effectiveDate)

          // Reset forminputs
          this.formInputs.valueset = (!isEmpty(this.$store.state.terminology.valueSetActive))
            ? selectedValueSet
            : this.valueSets?.[0] || null
          this.formInputs.keepIds = 'true'
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
  .transparentBackground::v-deep tbody {
     tr {
        background-color: transparent !important;
     }
  }
</style>
